import * as types from '../actions/actionTypes';
import initialState from './initialState';

export default function resourcePropsReducer(state = initialState.resourceProps, action) {
    switch(action.type){

        case types.SET_RESOURCES_PROPS:

            //debugger;
            //use immutable state with es6's spread operator (...) on existing state and Object.assign to make a deep copy of existing object to create a brand new state
			return Object.assign({},action.resourceProps);
        default:
            return state;
    }
}


/** WEBPACK FOOTER **
 ** ./src/reducers/resourcesPropsReducer.js
 **/